(ns iris.error.subs
  (:require
   [re-frame.core :as re-frame]))


(re-frame/reg-sub
 ::error
 (fn [db]
   (:error db)))